module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--socker",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cube panelLoad"
  }, [_c('div', {
    staticClass: "cube-face cube-face-front"
  }, [_vm._v("L")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-back"
  }, [_vm._v("O")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-left"
  }, [_vm._v("A")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-right"
  }, [_vm._v("D")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-bottom"
  }, [_vm._v("I")]), _vm._v(" "), _c('div', {
    staticClass: "cube-face cube-face-top"
  }, [_vm._v("N'")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74072f5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/LetterCube.vue
// module id = 938
// module chunks = 170